import {ServiceTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
export function invoiceServiceTypeNameFilter(type: ServiceTypeEnum): string {
  switch(type) {
    case ServiceTypeEnum.Food: return i18n.t(LF.CourierInvoiceServiceType) as string;
    case ServiceTypeEnum.Taxi: return i18n.t(LF.TransportInvoiceServiceType) as string;
  }
}
